import axios from "axios";
import React from "react";
import { jsonHeader } from '../util/GeneralUtil'
const apiUrl = process.env.REACT_APP_API_URL;


async function getMaster(payload) {
    const result = await axios.post(apiUrl + "/admin/dropdown/getmasters",payload,{
         headers: jsonHeader}
    );
    return result.data || [];
}

async function getBrokers(payload) {
    const result = await axios.post(apiUrl + "/admin/dropdown/getbrokers",payload,{
         headers: jsonHeader}
    );
    return result.data || [];
}

async function tradeSearch(payload) {
    const result = await axios.post(apiUrl + "/trade/search",payload,{
         headers: jsonHeader}
    );
    return result.data || [];
}

async function getUsers(payload) {
    const resultuser = await axios.post(apiUrl + "/admin/getusers",payload,{
         headers: jsonHeader}
    );
    return resultuser.data || [];
}
async function editTable(payload) {
    const resultuser = await axios.post(apiUrl + "/trade/editorder",payload,{
         headers: jsonHeader}
    );
    return resultuser.data || [];
}
async function deleteData(payload) {
    const resultuser = await axios.post(apiUrl + "/trade/deleteorder",payload,{
         headers: jsonHeader}
    );
    return resultuser.data || [];
}
async function editTableExecuted(payload) {
    const resultuser = await axios.post(apiUrl + "/trade/executed/editorder",payload,{
         headers: jsonHeader}
    );
    return resultuser.data || [];
}
async function deleteDataExecuted(payload) {
    const resultuser = await axios.post(apiUrl + "/trade/executed/deleteorder",payload,{
         headers: jsonHeader}
    );
    return resultuser.data || [];
}

export const TradeService = {
    getMaster,
    getUsers,
    tradeSearch,
    getBrokers,
    editTable,
    deleteData,
    editTableExecuted,
    deleteDataExecuted
}